import { defineCoach } from '../../types';

/** C08: observes the person’s real workflow; navigation is read-only and mutations belong to the page. Arabic copy is DRAFT. */
export const C08 = defineCoach({
  id: 'C08',
  version: 1,
  portal: 'platform',
  titleKey: 'guidance.coaches.C08.title',
  summaryKey: 'guidance.coaches.C08.summary',
  eligible: (ctx) => ctx.portal === 'platform' && ctx.can('platform.tenant.provision'),
  steps: [
    {
      id: 'c08-welcome',
      kind: 'explain',
      page: 'platform.organisations',
      anchor: null,
      titleKey: 'guidance.coaches.C08.welcome.title',
      bodyKey: 'guidance.coaches.C08.welcome.body',
      route: 'platform.organisations',
    },
    {
      id: 'c08-open',
      kind: 'await',
      page: 'platform.organisations',
      anchor: 'platform.orgs.create',
      titleKey: 'guidance.coaches.C08.open.title',
      bodyKey: 'guidance.coaches.C08.open.body',
      until: {
        route: 'platform.organisation-new',
      },
    },
    {
      id: 'c08-details',
      kind: 'explain',
      page: 'platform.organisation-new',
      anchor: 'platform.create.commit',
      titleKey: 'guidance.coaches.C08.details.title',
      bodyKey: 'guidance.coaches.C08.details.body',
    },
    {
      id: 'c08-create-handoff',
      kind: 'handoff',
      page: 'platform.organisation-new',
      anchor: 'platform.create.commit',
      titleKey: 'guidance.coaches.C08.create-handoff.title',
      bodyKey: 'guidance.coaches.C08.create-handoff.body',
      consequenceKey: 'guidance.coaches.C08.create-handoff.consequence',
    },
    {
      id: 'c08-create',
      kind: 'await',
      page: 'platform.organisation-new',
      anchor: 'platform.create.commit',
      titleKey: 'guidance.coaches.C08.create.title',
      bodyKey: 'guidance.coaches.C08.create.body',
      until: {
        outcome: 'platform.organisation.provisioned',
        route: 'platform.organisation-new',
        probe: {
          anchor: 'platform.create.provisioned',
          in: ['handed_to_mail_transport', 'not_sent'],
        },
      },
    },
    {
      id: 'c08-result',
      kind: 'explain',
      page: 'platform.organisation-new',
      anchor: 'platform.create.provisioned',
      titleKey: 'guidance.coaches.C08.result.title',
      bodyKey: 'guidance.coaches.C08.result.body',
    },
    {
      id: 'c08-finish',
      kind: 'finish',
      page: 'platform.organisation-new',
      anchor: null,
      titleKey: 'guidance.coaches.C08.finish.title',
      bodyKey: 'guidance.coaches.C08.finish.body',
    },
  ],
});
